export const buildLoginBody = () => {
    return {
        login: document.getElementById('login').value,
        password: document.getElementById('pass').value
    }
}

export const validateLogin = (body) => {
    if(body.login === null || body.login === ''){
        throw new Error('Usuario vacío');
    }

    if(body.password === null || body.password === ''){
        throw new Error('Contraseña vacía');
    }
}